// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu___1L63y","right":"right___3L8KG","action":"action___LP4_P","search":"search___2W0sJ","account":"account___6HXOq","avatar":"avatar___2cOWV","dark":"dark___1NwCY","name":"name___WfKAK"};
    if(module.hot) {
      // 1784537098667
      var cssReload = require("/usr/src/app/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  